<template>
    <div class="tpl-content-wrapper">
        <div class="tpl-portlet-components">
            <ul class="user-lab-info-box ml-4">
                <!--<li>-->
                <!--<ul>-->
                <!--<li><i class="fa fa-award" style="font-size: 32px;"/></li>-->
                <!--<li class="user-level">-->
                <!--<span>活跃等级</span>-->
                <!--<span class="level-num"><i>1 级</i>-->
                <!--<img src="https://static.shiyanlou.com/frontend/dist/img/6c8e136.png"></span>-->
                <!--<p>距 2 楼还需 30 分钟有效学习时间</p></li>-->
                <!--</ul>-->
                <!--</li>-->
                <li>
                    <ul>
                        <li><img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAAAXNSR0IArs4c6QAAAcJJREFUSA3lVi1Pw1AU7Qdk1FXgICQIHIIPBxrkNCR1kFSswyxBwh9AsVbMYuAnEBBT4AYEJIIEgiEozNhIO84l75HR3vdeQwgCmjTv7dxzz3n39X3Msn7psU0+zWbzcDAYrOl4tm0f1ev1dR1nRBcUsQPHcZ6yLNuC4B7eR4FPAmsgto+BHJt0jBWRQJIkS2manrmuO1+r1a4ENgfsEtgysHOTkWMi/FT8nxphAYzSFOKjv8mplH0Zk7iqLTV1WF2zEEx933+QQtQnjGIS07WljDD6TYi0gyB4kWKi34bRhsR0rXF5x3G8ArETjP4VQt2cmIdBjGEvrUZRdJqLfflp3LAQ2qYMEkRDb+ERHK2RtiJUs4BqOgVlBkBVi6jqggl9QNpvJKtRJQ/jJq6yIhym0xC6hYA7LKjq0wpEbAaH6x3HUVYEg0ZZExImLuVwJoSxFbVarfFer3ePuKdKVODdSqUyFYbhcz7OVtTv96NvmJC2J3LzPhZrhCkICsySgCqXNcKHnSipW6CpclkjjOqmoFAeuOaorBFuzR2QMy7BgGXYuLschzXC1Uz/Aap4O5iKz6uBEyBMcOgEqYpcFfUP4e/uIKgiM9VaVQAAAABJRU5ErkJggg=="
                        ></li>
                        <li>
                            我的文章 {{login_user_info.all_post_count}} 篇
                        </li>
                    </ul>
                </li>
                <li>
                    <ul>
                        <li><img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAAAXNSR0IArs4c6QAAAZVJREFUSA3tVTtOhFAU5aNT2FOYmFjMMtiB1egmKKCdxEJ7dVoo2IRONYUWVnYsQWqbaewMJuA5CUPufcCMMtgYb/LC/Z7zftxnWf8ycAfsXXVpmh4WRTFDHodfVdUxa2zbfsPnBWM5mUyWQRB80t8nW4niOD4vy3KB4mkfQO3PHceZR1H00JfXSYRZO0mS3IBk3lfY5QfZIgzDS6y2NOOu6aDted7tT0lYhwn6WZYdrVarJ9pSWiuqt+teJgmdM3WE3aliZRfmNqoiHnx9Jp0A2JIzjLvOoHASg1jCpWdX367eg3ddd43tWUuAHn1aYzVhtSJ4eYXHEoVlEvljsQBHYSmizc84BpmJdTAA9BG36l3WAfQE41r6TF0Rsa2g4NRM2ti4TTPkPCPndePjF/aHtKkTS/oUEQLsXduIrhDn+I4QqxF1RvAum8j+isJSROzCwM/357DyGquBUkRs9ezCTXSgQgzz2VBExGWPQiKfhkHCWrPPEahFRCdb/RAy1rCWGKa0urdM+PWHT5KN9ZRLzL+hfwGe7qCDRI0L1gAAAABJRU5ErkJggg=="
                        ></li>
                        <li v-if="login_user_info.is_vip">
                            <button style="border: none;background-color: #cfae68;">vip会员</button>
                        </li>
                        <li v-else>
                            <button style="border: none;background-color: #cfae68;">普通会员</button>
                        </li>
                        <li v-if="login_user_info.is_vip">{{login_user_info.vip_end_date}}到期</li>
                    </ul>
                    <el-button type="text" @click="dialogTableVisible = true">消费记录</el-button>
                    <el-button type="text" @click="dialogTableVisible2 = true">充值记录</el-button>
                    <el-dialog title="我的消费记录" :visible.sync="dialogTableVisible">
                        <el-table :data="get_login_user_expense_record" height="250"
                                  :row-class-name="tableRowClassName">
                            <el-table-column property="created_at" label="日期" width="150"></el-table-column>
                            <el-table-column property="number" label="消费单号" width="220"></el-table-column>
                            <el-table-column property="expense_item_name" label="消费项目"
                                             width="220"></el-table-column>
                            <el-table-column property="expense_item_type" label="消费类型"></el-table-column>
                            <el-table-column property="total" label="消费金额"></el-table-column>
                            <el-table-column property="state" label="状态"></el-table-column>
                        </el-table>
                    </el-dialog>
                    <el-dialog title="我的充值记录" :visible.sync="dialogTableVisible2">
                        <el-table :data="get_login_user_pay_record" height="250"
                                  :row-class-name="tableRowClassName">
                            <el-table-column property="created_at" label="日期" width="150"></el-table-column>
                            <el-table-column property="name" label="充值单号" width="220"></el-table-column>
                            <el-table-column property="pay_type" label="充值方式"></el-table-column>
                            <el-table-column property="amount" label="充值金额"></el-table-column>
                            <el-table-column property="state" label="状态"></el-table-column>
                        </el-table>
                    </el-dialog>
                </li>
                <li>
                    <ul>
                        <li><img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAAAXNSR0IArs4c6QAAAhJJREFUSA3tVT1Lw0AYbpJah3QQBRUcBEVR3Bz8GEScFEQEwc1JKMXWFhTUyUkXwUFLC1aEYiYXFwcriBZ0EZrBxaGDaP+AVtoOaWnrc6IS3rvExlE8OHLvc8/H5XJJXK7/9ssdkH6ji8Vi/ZVKZQfacXRDkqSbWq22Hw6Hb638HAdFIpEhGF/B2Csw3QuFQquYr9E5hQJ2taZpqmEYLKTNgjeSTqcbk8nkFZ2XKWBX53K5TYR02XEwvx6NRgcop+4giFsgXqYGglquVqtLFK8rKB6PN0C4i65+Ghy53e4+amaqJ0zjj6GbAuY6kUg0FQqFjVKptIgtaWVzeND3Xq93rVgs+s1cMu4ktcsyCFs1iJAzBHQwEQKecDlASAT4HPBtamaqOV8OYGSE9GKfLzFs/hIjaAq9I5/PnwCb/cItri8U554RViqhayB+hzARgjN4Sa8x/CmE3f0D05gbF4S7mUHQsJnkdAx9imq4IBAWKMlpjRN5SjVcEFYzSklOamzbZSAQyFANFwRCOyU5qbHQLRGfC8KK3kTEejBoj62+4FwQDO/qMRVwHhVFWRHgHxAXJMty1Ipsg7/gAEzj2bxacbigYDB4gS04tBJQHNysx+MZEx0AM1f4PzpH03WdzbETKOQwE4RoqqrO+3y+LKvtmu0fFl/t7nK57MdXYRImPegKzJ/RUzhdR/ib6nbmf3vuHT2csVs1L8nCAAAAAElFTkSuQmCC"
                        ></li>

                        <li class="beans" style="margin-top: 3px">
                            <span>
                                <span class="label label-sm label-warning">金币</span>
                                <span class="margin-right-10">{{login_user_coin_count.gold_count.toFixed(2)}}</span>
                                <span class="label label-sm label-default">银币</span>
                                <span class="margin-right-10">{{login_user_coin_count.silver_count}}</span>
                                <span class="label label-sm label-success">铜币</span>
                                <span class="margin-right-10">{{login_user_coin_count.copper_count}}</span>
                            </span>
                            <span>
                                <el-button type="text" @click="dialogTableVisible3 = true">充值</el-button>
                                <el-dialog title="充值" :visible.sync="dialogTableVisible3">
                                    <Pay></Pay>
                                </el-dialog>
                            </span>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="tpl-portlet-components">
            <ul class="nav_title_ul">
                <li class="nav_title_li">
                    关注排行
                </li>
            </ul>
            <FollowSide></FollowSide>
        </div>
    </div>

</template>
<script type="text/javascript">
    // import Courses from './sub_components/courses.vue'
    // import Paths from './sub_components/paths.vue'
    // import Reports from './sub_components/reports.vue'
    // import Discuss from './sub_components/discuss.vue'
    import accountApi from '@/api/account/account.js'
    import UserApi from '@/api/user/user.js'
    import FollowSide from '@/components/main_page/sub_components/dashboard_follow.vue'
    import Pay from '@/components/pay_page/pay.vue'

    import {mapState, mapActions} from 'vuex'

    export default {
        components: {
            FollowSide,
            Pay,
            // Courses,
            // Paths,
            // Reports,
            // Discuss
        },
        data: function () {
            return {
                stuff_component_dict: {
                    '课程': 'Courses',
                    '路径': 'Paths',
                    '报告': 'Reports',
                    '讨论': 'Discuss'
                },
                login_user_coin_count: {},
                login_user_info: {},

                get_login_user_expense_record: [],
                get_login_user_pay_record: [],
                dialogTableVisible: false,
                dialogTableVisible2: false,
                dialogTableVisible3: false,
            }
        },
        computed: {
            ...mapState({
                sign_on: state => state.loginState.sign_on,
                nav_title: state => state.user.user_stuff_nav,
                user_id: state => state.user.user_id
            })
        },
        methods: {
            ...mapActions({}),

            tab_nav: function (title) {
                this.$store.dispatch('user/change_user_stuff', {
                    'nav_title': title
                })
            },
            tableRowClassName({row, rowIndex}) {
                if (row.state === '已完成') {
                    return 'success-row';
                } else if (row.state === '处理中') {
                    return 'warning-row';
                }
                return '';
            }
        },
        watch: {
            '$route': function () {
                this.tab_nav('课程')
            }
        },
        mounted() {
            accountApi.get_login_user_coin_count().then((res) => {
                this.login_user_coin_count = res.data
            })
            accountApi.get_login_user_expense_record().then((res) => {
                this.get_login_user_expense_record = res.data
            })
            accountApi.get_login_user_pay_record().then((res) => {
                this.get_login_user_pay_record = res.data
            })
            UserApi.get_login_user_info_by_cookies().then((res) => {
                this.login_user_info = res.data
            })
        }
    }

</script>
<style>
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>
<style type="text/css" scoped>
    .margin-right-10 {
        margin-right: 10px;
    }

    .stuff_board {
        margin-top: 10px;
        border: 1px solid #eee;
        background: #fff;
        padding: 30px;
        display: flex;
        flex-direction: column;
    }

    .nav_title_ul {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_title_li {
        font-size: 16px;
        padding: 3px 5px;
        padding-bottom: 7px;
        margin-right: 25px;
        margin-bottom: -1px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .nav_title_li:hover {
        border-bottom-color: #66CCFF;
    }

    .active_nav {
        border-bottom-color: #66CCFF;;
    }

    /* */

    .stuff_div {
        margin-top: 10px;
    }
</style>
